// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attachmentButton__attachmentButton___3xzYI{cursor:pointer;opacity:.8}.attachmentButton__attachmentButton___3xzYI:hover:enabled{opacity:1}.attachmentButton__fileInput___3rmck{display:none}", ""]);
// Exports
exports.locals = {
	"attachmentButton": "attachmentButton__attachmentButton___3xzYI",
	"fileInput": "attachmentButton__fileInput___3rmck"
};
module.exports = exports;
